import moment from "moment";
import axios from 'axios';




const OPENAI_API_KEY = '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';

export const generateTruckBio = async (truckName, cuisineType, city, features, popularItems, vendorType) => {
  try {
    const response = await axios.post(
      'https://api.openai.com/v1/chat/completions',
      {
        model: 'gpt-3.5-turbo',
        messages: [
          {
            role: 'system',
            content: 'You are a helpful assistant that generates creative bios for food trucks.'
          },
          {
            role: 'user',
            content: `Write a creative and engaging 255-word bio for a food truck named "${truckName}". It specializes in ${cuisineType} and is located in ${city}. It has the following features: ${features}. The two most popular items on the menu are: ${popularItems}. The vendor focuses on: ${vendorType}. make it 255 caracters only for validation purpouse`
          }
        ],
        max_tokens: 500,
        temperature: 0.7,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${OPENAI_API_KEY}`,
        },
      }
    );

    // Correctly extract the content from the response object
    return response.data.choices[0].message.content;
  } catch (error) {
    console.error('Error generating food truck bio:', error);
    return 'Failed to generate bio';
  }
};

export const getAverageMealPrice = (meals) => {
  if (!Array.isArray(meals) || meals.length === 0) return 20;
  const total = meals.reduce((sum, m) => sum + (parseFloat(m.price) || 0), 0);
  return Math.round((total / meals.length) * 100) / 100;
};

const getMenuSummary = (meals) => {
  if (!Array.isArray(meals) || meals.length === 0) return "No meals listed.";
  const preview = meals.slice(0, 5).map(m => `- ${m.name} ($${m.price})`).join("\n");
  return `Example Menu Items:\n${preview}`;
};
export const getEventAnalysis = async (eventName, similarEventsSummary, item, overrides = {}) => {
  const hometown = item?.hometown || "Melbourne";
  const avgMealPrice = getAverageMealPrice(item?.meals);
  const menuSummary = getMenuSummary(item?.meals);

  const { adults = 1, juniors = 1, manualFee = null } = overrides;

  try {
    // STEP 1: Create a new thread
    const threadResponse = await axios.post(
      "https://api.openai.com/v1/threads",
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${OPENAI_API_KEY}`,
          "OpenAI-Beta": "assistants=v2",
        },
      }
    );
    const threadId = threadResponse.data.id;

    // STEP 2: Add the user message into the thread
    const userMessage = `
Event Name: "${eventName}"
Truck Hometown: "${hometown}"
Average Meal Price: $${avgMealPrice}

Menu Summary:
${menuSummary}

Staff:
- Adult Staff: ${adults}
- Junior Staff: ${juniors}

Manual Event Fee: ${manualFee ? `$${manualFee}` : "None"}

Site Fee:
- Mode: ${item.siteFeeMode || "fixed"}
- Value: ${item.siteFeeValue || 0}${item.siteFeeMode === "percentage" ? "%" : "$"}

Power & Utilities Expense: $${item.powerUtilityFee || 0}

Owner Operator Truck: ${item.isOwnerOperator ? "Yes" : "No"}

📚 Historical Similar Event Logs:
${similarEventsSummary}

Please evaluate this event following the profitability analyst instructions stored in the assistant.

Provide a detailed, structured profitability analysis including:
✅ Verdict (YES/NO) + explanation
📍 Event Location
📅 Dates & Duration
⏰ Hours of Trade
👥 Crowd Profile
🎟️ Attendance Estimate
🍽️ Product-Market Fit
💸 Pricing Fit
🧾 Avg Spend per Customer
🍔 Est Serves Per Day
💰 Est Daily Revenue
💰 Est Total Revenue
💥 Cost Breakdown: fuel, accommodation, staffing, stock/prep, permits, site fee, power/utilities
📊 Net Profit
📈 ROI Verdict
👥 Staffing Suggestions
🎯 Smart Vendor Strategy

✅ Also note if similar events had food trucks historically (✅ or ❌).

Use emojis and symbols to make the analysis visually easy to read.

Think like a tactical, senior event strategist.
`;

    await axios.post(
      `https://api.openai.com/v1/threads/${threadId}/messages`,
      { role: "user", content: userMessage },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${OPENAI_API_KEY}`,
          "OpenAI-Beta": "assistants=v2",
        },
      }
    );

    // STEP 3: Run the assistant on the thread
    const runResponse = await axios.post(
      `https://api.openai.com/v1/threads/${threadId}/runs`,
      { assistant_id: 'asst_ZC7hvt7a1iNcS56k1YdHs0v2' }, // your assistant ID
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${OPENAI_API_KEY}`,
          "OpenAI-Beta": "assistants=v2",
        },
      }
    );

    const runId = runResponse.data.id;

    // STEP 4: Poll until the run is completed
    let runStatus = "in_progress";
    while (runStatus === "in_progress" || runStatus === "queued") {
      await new Promise(resolve => setTimeout(resolve, 2000)); // wait 2 seconds
      const runStatusResponse = await axios.get(
        `https://api.openai.com/v1/threads/${threadId}/runs/${runId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${OPENAI_API_KEY}`,
            "OpenAI-Beta": "assistants=v2",
          },
        }
      );
      runStatus = runStatusResponse.data.status;
    }

    // STEP 5: Fetch the messages from the thread
    const messagesResponse = await axios.get(
      `https://api.openai.com/v1/threads/${threadId}/messages`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${OPENAI_API_KEY}`,
          "OpenAI-Beta": "assistants=v2",
        },
      }
    );

    const messages = messagesResponse.data.data;
    const assistantReply = messages.find(msg => msg.role === "assistant");
    return assistantReply?.content?.[0]?.text?.value || "Could not fetch assistant reply.";
  } catch (error) {
    console.error("WTT Analysis failed:", error?.response?.data || error);
    return "Could not generate event analysis.";
  }
};


// HELPER


export const getEventSearchSuggestions = async ({
  weekNumber,
  startDate,
  endDate,
  truckDetails
}) => {
  try {
    const threadResponse = await axios.post(
      'https://api.openai.com/v1/threads',
      { }, // your assistant IDasst_rvjjn1q6FjeLfDQOAAObMxWc
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${OPENAI_API_KEY}`,
          'OpenAI-Beta': 'assistants=v2',
        },
      }
    );
    
    const threadId = threadResponse.data.id;
    
    const userPrompt = `
You are the AI Event Strategist for the Where The Truck (WTT) platform.

Your task is to return a list of **at least 20 confirmed or recurring public events** that are **happening during the specific calendar week**, suitable for a food truck to apply for.

Please format your answer in a clean, user-friendly list using bullet points. Include event name, date, and suburb/location.

Only include events that:
- Are scheduled during this specific week (${moment(startDate).format('DD MMM YYYY')} – ${moment(endDate).format('DD MMM YYYY')})
- Are known to occur annually or are already announced for this year
- Make sense for food truck participation (markets, festivals, sporting events, public pop-ups, exhibitions, etc.)

Avoid long descriptions, focus on the actual list of events with clarity.

📆 Week Info:
- Week Number: Week ${weekNumber}, ${moment(startDate).year()}
- Date Range: ${moment(startDate).format('DD MMM YYYY')} – ${moment(endDate).format('DD MMM YYYY')}

🚚 Truck Details:
- Cuisine Types: ${truckDetails.cuisines.join(', ')}
- Base Location: ${truckDetails.baseLocation}
- Travel Radius: 300 km
- Average Meal Price: $${truckDetails.avgMealPrice}
- Daily Sale Target: $${truckDetails.dailySaleTarget}
- Max Events This Week: ${truckDetails.maxEventsPerWeek}
- Catering Allowed: ${truckDetails.allowCatering ? 'Yes' : 'No'}
- Indoor Preferred: ${truckDetails.indoorPreferred ? 'Yes' : 'No'}
- Multi-Day Events Accepted: ${truckDetails.multiDayOk ? 'Yes' : 'No'}

🧠 Vendor Preferences:
- Event Focus: ${truckDetails.eventTypePriority || 'Public'}
- Pricing Style: ${truckDetails.userPreferences?.pricingPreference || 'Balanced'}
- Event Scale Preference: ${truckDetails.userPreferences?.eventScale || 'Let WTT decide'}

⏳ Reminder:
Return results as a list of **at least 20 distinct events** that are **real, and historically have food trucks region-appropriate, food-truck friendly**, and match the time period.
`;

    await axios.post(
      `https://api.openai.com/v1/threads/${threadId}/messages`,
      { role: 'user', content: userPrompt },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${OPENAI_API_KEY}`,
          'OpenAI-Beta': 'assistants=v2',
        },
      }
    );

    const runResponse = await axios.post(
      `https://api.openai.com/v1/threads/${threadId}/runs`,
      { assistant_id: "asst_ZC7hvt7a1iNcS56k1YdHs0v2" },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${OPENAI_API_KEY}`,
          'OpenAI-Beta': 'assistants=v2',
        },
      }
    );

    const runId = runResponse.data.id;
    let runStatus = 'in_progress';

    while (runStatus === 'in_progress' || runStatus === 'queued') {
      await new Promise(resolve => setTimeout(resolve, 2000));
      const statusRes = await axios.get(
        `https://api.openai.com/v1/threads/${threadId}/runs/${runId}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${OPENAI_API_KEY}`,
            'OpenAI-Beta': 'assistants=v2',
          },
        }
      );
      runStatus = statusRes.data.status;
    }

    const messagesRes = await axios.get(
      `https://api.openai.com/v1/threads/${threadId}/messages`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${OPENAI_API_KEY}`,
          'OpenAI-Beta': 'assistants=v2',
        },
      }
    );

    const messages = messagesRes.data.data;
    const reply = messages.find(msg => msg.role === 'assistant');
    return reply?.content?.[0]?.text?.value || 'No suggestion returned.';
  } catch (error) {
    console.error('WTT Event Search Suggestion failed:', error?.response?.data || error);
    return 'Unable to fetch event search suggestions.';
  }
};



export const getWorkforceStrategy = async (eventName, eventDate, projectedSales, item, overrides = {}) => {
  const hometown = item?.hometown || "Melbourne";
  const avgMealPrice = getAverageMealPrice(item?.meals);
  const menuSummary = getMenuSummary(item?.meals);

  const { adults = 1, juniors = 1, venueName = "Default Venue" } = overrides;

  try {
    // STEP 1: Create a new thread
    const threadResponse = await axios.post(
      "https://api.openai.com/v1/threads",
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${OPENAI_API_KEY}`,
          "OpenAI-Beta": "assistants=v2",
        },
      }
    );
    const threadId = threadResponse.data.id;

    // STEP 2: Add the user message into the thread
    await axios.post(
      `https://api.openai.com/v1/threads/${threadId}/messages`,
      {
        role: "user",
        content: `
You are Workforce Rostering Strategist GPT.

Here is the event information:

Event Name: "${eventName}"
Event Date: "${eventDate}"
Projected Sales: $${projectedSales}
Venue: "${venueName}"
Truck Hometown: "${hometown}"



Staff Forecast:
- Adult Staff: ${adults}
- Junior Staff: ${juniors}

Please generate a full tactical roster plan according to these rules:
- Labour cost must stay around 11% of projected sales.
- Apply correct Fair Work Hospitality Award rates for weekdays, weekends, and public holidays.
- Recommend staffing numbers, shift times, roles, hourly rates, and show total labour cost.
- Show busy periods based on typical food truck events.
- Show labour cost % vs sales.
- Confirm award compliance.
- Provide optimization suggestions if needed.

Format the output using the Roster Recommendation Template I gave you earlier.
        `
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${OPENAI_API_KEY}`,
          "OpenAI-Beta": "assistants=v2",
        },
      }
    );

    // STEP 3: Run the assistant on the thread
    const runResponse = await axios.post(
      `https://api.openai.com/v1/threads/${threadId}/runs`,
      {
        assistant_id: 'asst_e9jYBQ1Ck8y8Uar8m0dL6KLN', // 🧠 <- Use your Workforce-specific assistant ID
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${OPENAI_API_KEY}`,
          "OpenAI-Beta": "assistants=v2",
        },
      }
    );

    const runId = runResponse.data.id;

    // STEP 4: Poll until the run is completed
    let runStatus = "in_progress";
    while (runStatus === "in_progress" || runStatus === "queued") {
      await new Promise(resolve => setTimeout(resolve, 2000)); // wait 2 seconds
      const runStatusResponse = await axios.get(
        `https://api.openai.com/v1/threads/${threadId}/runs/${runId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${OPENAI_API_KEY}`,
            "OpenAI-Beta": "assistants=v2",
          },
        }
      );
      runStatus = runStatusResponse.data.status;
    }

    // STEP 5: Fetch the messages from the thread
    const messagesResponse = await axios.get(
      `https://api.openai.com/v1/threads/${threadId}/messages`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${OPENAI_API_KEY}`,
          "OpenAI-Beta": "assistants=v2",
        },
      }
    );

    const messages = messagesResponse.data.data;
    const assistantReply = messages.find(msg => msg.role === "assistant");

    return assistantReply?.content?.[0]?.text?.value || "Could not fetch roster recommendation.";
  } catch (error) {
    console.error("Assistant API Workforce Strategy Failed:", error?.response?.data || error);
    return "Could not generate workforce strategy.";
  }
};














export const generateCateringTruckBio = async (truckName, cuisineType, city, features, popularItems, vendorType) => {
  try {
    const response = await axios.post(
      'https://api.openai.com/v1/chat/completions',
      {
        model: 'gpt-3.5-turbo',
        messages: [
          {
            role: 'system',
            content: 'You are a helpful assistant that generates creative bios for food trucks.'
          },
          {
            role: 'user',
            content: `Write a creative and engaging 255-word bio for a food truck named "${truckName}". It specializes in ${cuisineType} and is located in ${city}. It has the following features: ${features}. The two most popular items on the menu are: ${popularItems}. The vendor focuses on: ${vendorType}. make it 255 caracters `
          }
        ],
        max_tokens: 500,
        temperature: 0.7,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${OPENAI_API_KEY}`,
        },
      }
    );

    // Correctly extract the content from the response object
    return response.data.choices[0].message.content;
  } catch (error) {
    console.error('Error generating food truck bio:', error);
    return 'Failed to generate bio';
  }
};

export const generateMealDescription = async (truckName, cuisineType, city, features, popularItems, vendorType) => {
  try {
    const response = await axios.post(
      'https://api.openai.com/v1/chat/completions',
      {
        model: 'gpt-3.5-turbo',
        messages: [
          {
            role: 'system',
            content: 'You are a helpful assistant that generates creative bios for food trucks.'
          },
          {
            role: 'user',
            content: `Write a creative and engaging 255-word bio for a food truck named "${truckName}". It specializes in ${cuisineType} and is located in ${city}. It has the following features: ${features}. The two most popular items on the menu are: ${popularItems}. The vendor focuses on: ${vendorType}. make it 255 caracters `
          }
        ],
        max_tokens: 500,
        temperature: 0.7,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${OPENAI_API_KEY}`,
        },
      }
    );

    // Correctly extract the content from the response object
    return response.data.choices[0].message.content;
  } catch (error) {
    console.error('Error generating food truck bio:', error);
    return 'Failed to generate bio';
  }
};


export const hasEventExpired = (eventDetails, type) => {
  // Ensure the current timestamp is in the correct format
  var currentTimestamp = moment().format("DD MMM YYYY hh:mm A");

  // Construct event start and end timestamps
  var eventStartTimestamp = moment(eventDetails.start_date + " " + eventDetails.start_time, "DD MMM YYYY hh:mm A");
  var eventEndTimestamp = moment(eventDetails.end_date + " " + eventDetails.end_time, "DD MMM YYYY hh:mm A");

  // Calculate differences with the current timestamp
  var diffWithEnd = eventEndTimestamp.diff(moment(currentTimestamp, "DD MMM YYYY hh:mm A"), "minutes");
  var diffWithStart = eventStartTimestamp.diff(moment(currentTimestamp, "DD MMM YYYY hh:mm A"), "minutes");

  // Adjust the end time difference for specific event types
  if (type === "food") {
    if (
      eventDetails.event_type === "catering" ||
      eventDetails.event_type === "ftims" ||
      eventDetails.event_type === "private"
    ) {
      diffWithEnd += 60;
    }
  }

  // Determine if the event has expired
  if (diffWithEnd < 0) {
    return true;
  } else {
    return false;
  }
};
